import React from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Close as CloseIcon } from "../icons";

// ✕ al final de los buscadores para borrar lo escrito. Llama al mismo
// onChange del TextField con un evento de valor vacío, así cada pantalla
// sigue usando su propio handler (que puede hacer más que guardar el texto).
const SearchClearAdornment = ({ value, onChange }) => {
  if (!value) return null;
  return (
    <InputAdornment position="end">
      <IconButton
        size="small"
        edge="end"
        aria-label="Borrar búsqueda"
        onClick={() => onChange({ target: { value: "" } })}
        sx={{ color: "inherit", opacity: 0.7 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </InputAdornment>
  );
};

export default SearchClearAdornment;
